'use strict';

var moduleName = 'footer-sticky';

module.exports = function () {
	$('[js-footer]').each(function () {
		if($.data(this, moduleName + '-init')) return;
		$.data(this, moduleName + '-init', true);



		var wrap = $(this);



		$(window).on('load resize', function() {
			var height = wrap.outerHeight();

			wrap.css({'position' : 'absolute'});
			$('body').css({'margin-bottom' : height});
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/footerStickyInit.js
 **/